export const A_DOLLAR = 100_000;

export const A_SANE_CAP = 10_000 * A_DOLLAR;

export function moneyFrom(said: string): number | null {
  const asked = said.trim().replace(/^\$/, "").replace(/,/g, "");
  if (!/^\d{1,9}(\.\d{1,5})?$/.test(asked)) return null;
  return Math.round(Number(asked) * A_DOLLAR);
}

export function moneySaid(amount: number): string {
  if (amount > 0 && amount < A_DOLLAR / 200) return "under $0.01";
  return `$${(amount / A_DOLLAR).toFixed(2)}`;
}

export function tokensSaid(tokens: number): string {
  if (tokens < 1_000) return `${tokens}`;
  if (tokens < 1_000_000) return `${Math.round(tokens / 1_000)}k`;
  return `${(tokens / 1_000_000).toFixed(1)}M`;
}
